import { render } from "./AntiBullyingDetail.vue?vue&type=template&id=a97b5c3e&scoped=true"
import script from "./AntiBullyingDetail.vue?vue&type=script&lang=js"
export * from "./AntiBullyingDetail.vue?vue&type=script&lang=js"

import "./AntiBullyingDetail.vue?vue&type=style&index=0&id=a97b5c3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97b5c3e"]])

export default __exports__